import { CartUpsellingToolInput, LensPackage, Package } from "./types";

const PROPS_TO_COMPARE: Array<keyof LensPackage> = [
  "antiFog",
  "antiReflective",
  "type",
  "brand",
  "treatmentFamily",
  "designType",
  "uvProtection",
  "thickness",
  "blueLight",
  "transition",
  "color",
  "colorCategory",
  "antiScratch",
];

export function getSameLensesLessThanProps(
  selected: LensPackage,
  lessThanProps: string[],
  lenses: CartUpsellingToolInput["_packages"],
  propToCheck: keyof LensPackage,
) {
  const props = PROPS_TO_COMPARE.filter((p) => !lessThanProps.includes(p));

  return lenses?.filter(
    ({ lensPackage }) =>
      props.every((p) => {
        return (
          selected[p] === lensPackage[p] || (!selected[p] && !lensPackage[p])
        );
      }) &&
      ((lensPackage.upc === selected.upc &&
        lensPackage[propToCheck] === selected[propToCheck]) ||
        (lensPackage.upc !== selected.upc &&
          lensPackage[propToCheck] !== selected[propToCheck])),
  );
}

export function sortForPrice(a: Package, b: Package) {
  const aPrice = parseFloat(
    String(a.lensPackage.offerPrice ?? a.lensPackage.listPrice),
  );
  const bPrice = parseFloat(
    String(b.lensPackage.offerPrice ?? b.lensPackage.listPrice),
  );
  return aPrice - bPrice;
}

export function getFirstSuggestion(
  selected: LensPackage,
  lenses: CartUpsellingToolInput["_packages"],
) {
  const [noArLensPackage, standardArLensPackage, premiumArLensPackage] =
    getSameLensesLessThanProps(
      selected,
      ["antiReflective"],
      lenses,
      "antiReflective",
    )?.sort(sortForPrice) ?? [];

  //no anti-reflective case
  if (
    (selected.catEntryId &&
      noArLensPackage?.lensPackage?.catEntryId === selected.catEntryId) ||
    (selected.upc && noArLensPackage?.lensPackage?.upc === selected.upc)
  ) {
    //upsell to standard anti-reflective
    return standardArLensPackage;
  } else if (
    //standard case
    (selected.catEntryId &&
      standardArLensPackage?.lensPackage?.catEntryId === selected.catEntryId) ||
    (selected.upc && standardArLensPackage?.lensPackage?.upc === selected.upc)
  ) {
    //upsell to premium anti-reflective
    return premiumArLensPackage;
  } else if (
    //premium case
    (selected.catEntryId &&
      premiumArLensPackage?.lensPackage?.catEntryId === selected.catEntryId) ||
    (selected.upc && premiumArLensPackage?.lensPackage?.upc === selected.upc)
  ) {
    return null;
  } else {
    console.log("Impossible upsell anti-reflactive (first option)");
    return null;
  }
}

export function getSecondSuggestion(
  selected: LensPackage,
  lenses: CartUpsellingToolInput["_packages"],
) {
  const sameLenses = getSameLensesLessThanProps(
    selected,
    [
      "blueLight",
      "transition",
      "treatment",
      "treatmentFamily",
      "colorCategory",
    ],
    lenses,
    "blueLight",
  );

  //clear case
  if (!selected.blueLight && !selected.transition && sameLenses) {
    //upsell to blue-light
    return (
      sameLenses
        .filter((l) => l.lensPackage.blueLight && !l.lensPackage.transition)
        .sort(sortForPrice)
        .shift() ?? null
    );
  } else {
    // blue-light case
    if (selected.blueLight && !selected.transition && sameLenses) {
      return (
        sameLenses
          .filter(
            (l) =>
              l.lensPackage.blueLight &&
              !l.lensPackage.transition &&
              l.lensPackage.blueLight !== selected.blueLight,
          )
          .sort(sortForPrice)
          .shift() ?? null
      );
    } else {
      //blue-light and transition case
      return null;
    }
  }
}

export function getThirdSuggestion(
  selected: LensPackage,
  lenses: CartUpsellingToolInput["_packages"],
) {
  const data = getSameLensesLessThanProps(
    selected,
    ["brand", "designType"],
    lenses,
    "brand",
  )
    ?.filter(
      (p) =>
        p.lensPackage.brand != selected.brand &&
        parseFloat(
          String(p.lensPackage.offerPrice ?? p.lensPackage.listPrice),
        ) > parseFloat(String(selected.offerPrice ?? selected.listPrice)),
    )
    ?.sort(sortForPrice);

  if (
    data?.[0] &&
    parseFloat(
      String(data[0].lensPackage.offerPrice ?? data[0].lensPackage.listPrice),
    ) > parseFloat(String(selected.offerPrice ?? selected.listPrice))
  ) {
    return data[0];
  } else {
    return null;
  }
}

export function getFourthSuggestion(
  selected: LensPackage,
  lenses: CartUpsellingToolInput["_packages"],
) {
  const [noAntiFogLensPackage, antiFogPackage] =
    getSameLensesLessThanProps(selected, ["antiFog"], lenses, "antiFog")?.sort(
      sortForPrice,
    ) ?? [];

  //no anti-antifog case
  if (
    (selected?.catEntryId &&
      noAntiFogLensPackage?.lensPackage?.catEntryId === selected.catEntryId) ||
    (selected?.upc && noAntiFogLensPackage?.lensPackage?.upc === selected.upc)
  ) {
    //upsell to antifog package
    return antiFogPackage ?? null;
  } else if (
    (selected?.catEntryId &&
      antiFogPackage?.lensPackage?.catEntryId === selected.catEntryId) ||
    (selected?.upc && antiFogPackage?.lensPackage?.upc === selected.upc)
  ) {
    //package alredy have antifog
    return null;
  } else {
    console.log("Impossible upsell anti-fog (first option)");
    return null;
  }
}
